import React, { forwardRef } from 'react';
import Search from '../../Search/organisms/LandingSearch';
import './styles.css';

const LandingSearch = forwardRef((_props, ref) => {
  return (
    <div ref={ref} className="Landing__Search__root">
      <Search />
    </div>
  );
});

export default LandingSearch;
